/* Document ready functions */
jQuery(document).ready(function ($){

    var booking_location = 'asplund';

    // Default: arrival tomorrow, departure two days after arrival (same as the PHP booking buttons)
    var start_date = new Date();
    start_date.setDate(start_date.getDate() + 1);

    var end_date = new Date(start_date);
    end_date.setDate(end_date.getDate() + 2);

    function formatDate(date) {
        var d = (date.getDate() < 10 ? '0' : '') + date.getDate();
        var m = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
        return date.getFullYear()+'-'+m+'-'+d;
    }

    function updateBookingUrl() {
        // Keep departure after arrival if only arrival has been changed
        if (end_date <= start_date) {
            end_date = new Date(start_date);
            end_date.setDate(end_date.getDate() + 2);
        }

        var booking_url = 'https://'+booking_location+'.nitesoft.se/units/'+formatDate(start_date)+'/'+formatDate(end_date)+'//2/0';
        $('.booking_btn').attr('href', booking_url);
    }

    updateBookingUrl();

    var picker = new Pikaday({
        field: document.getElementById('arrival'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
        },
        minDate: new Date(),
        onSelect: function () {
          picker2.setMinDate(this.getDate());

          start_date = this.getDate();
          updateBookingUrl();
        }
    });

    var picker2 = new Pikaday({
        field: document.getElementById('departure'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
      },
      onSelect: function () {
        end_date = this.getDate();
        updateBookingUrl();
      }
    });

    var picker3 = new Pikaday({
        field: document.getElementById('arrival-top'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
        },
        minDate: new Date(),
        onSelect: function () {
          picker4.setMinDate(this.getDate());

          start_date = this.getDate();
          updateBookingUrl();
        }
    });

    var picker4 = new Pikaday({
        field: document.getElementById('departure-top'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
      },
      onSelect: function () {
        end_date = this.getDate();
        updateBookingUrl();
      }
    });


});
